export const ACTIVE = 'active'
export const INACTIVE = 'inactive'
export const AREA_STATUS = {
  ACTIVE,
  INACTIVE
}
